import { useContext } from 'react';
import { getUserRoles } from '../features/common/Common.utils';
import { ConfigurationContext } from '../providers/ConfigurationProvider';

function useIsAdminRole(): boolean {
  const userRoles = getUserRoles();

  const config = useContext(ConfigurationContext);

  const isAdminRole = userRoles.some((role) =>
    config?.ADMIN_ROLES.includes(role)
  );

  return isAdminRole || false;
}

export default useIsAdminRole;
